import React from 'react';
const BrandMarquee: React.FC = () => {
  const brandLogos = [{
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/nicobar-mz70b2cmlmf.webp',
    alt: 'Nicobar',
    width: 160,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/olio-a5i9896ear.webp',
    alt: 'Olio',
    width: 120,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/yogasleep-nbbiioplt7.webp',
    alt: 'Yogasleep',
    width: 207,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/kwiat-sdnz85o8l0t.webp',
    alt: 'Kwiat',
    width: 72,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/pant-project-r0m6fnqyfm.webp',
    alt: 'The Pant Project',
    width: 185,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/pratapsons-jzthhi3mvwr.webp',
    alt: 'Pratap Sons Global',
    width: 160,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/rifruf-33sm2yy6ayw.webp',
    alt: 'Rifruf',
    width: 120,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/sammmm-j48ng10z8ug.webp',
    alt: 'Sammmm',
    width: 160,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/snap-kitchen-r312aihhob.webp',
    alt: 'Snap Kitchen',
    width: 160,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/spin-a1kqixndrvc.webp',
    alt: 'Spin',
    width: 96,
    height: 36
  }, {
    url: 'https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_240,f_auto,q_auto/https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmkgdrd82009cwf0ybu6o3ras/messages/youngevity-mkr3us0suwc.webp',
    alt: 'Youngevity',
    width: 185,
    height: 36
  }];
  return <section data-name="Brand Marquee" className="max-[768px]:py-12 bg-cream py-16 overflow-x-hidden mt-0 mb-0 ml-0 mr-0 pl-0 pr-0">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-20">
        <div className="flex items-center gap-12 max-[768px]:flex-col max-[768px]:gap-8">
          {/* Static Text */}
          <div className="flex-shrink-0">
            <p className="text-primary text-[14px] font-medium tracking-[0.03em] uppercase whitespace-nowrap [font-family:Aeonik-Pro,sans-serif]">
              Trusted by teams at
            </p>
          </div>

          {/* Marquee Container */}
          <div className="flex-1 relative overflow-hidden">
            {/* Left Fade */}
            <div className="absolute left-0 top-0 bottom-0 w-[100px] bg-gradient-to-r from-cream to-transparent z-10 pointer-events-none"></div>

            {/* Marquee Track */}
            <div className="flex gap-11 marquee-animation max-[768px]:gap-10 max-[768px]:marquee-animation-mobile">
              {/* First set of logos */}
              {brandLogos.map((logo, index) => <div key={`logo-1-${index}`} className="flex-shrink-0">
                  <img src={logo.url} alt={logo.alt} width={logo.width} height={logo.height} className="h-9 max-[768px]:h-6 w-auto object-contain" />
                </div>)}
              {/* Duplicate set for seamless loop */}
              {brandLogos.map((logo, index) => <div key={`logo-2-${index}`} className="flex-shrink-0">
                  <img src={logo.url} alt={logo.alt} width={logo.width} height={logo.height} className="h-9 max-[768px]:h-6 w-auto object-contain" />
                </div>)}
              {/* Third set for seamless loop */}
              {brandLogos.map((logo, index) => <div key={`logo-3-${index}`} className="flex-shrink-0">
                  <img src={logo.url} alt={logo.alt} width={logo.width} height={logo.height} className="h-9 max-[768px]:h-6 w-auto object-contain" />
                </div>)}
            </div>

            {/* Right Fade */}
            <div className="absolute right-0 top-0 bottom-0 w-[100px] bg-gradient-to-l from-cream to-transparent z-10 pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>;
};
export default BrandMarquee;